var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3121_70345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1667 44.1667H38.5V40.5C38.5 39.4875 37.6792 38.6667 36.6667 38.6667C35.6542 38.6667 34.8334 39.4875 34.8334 40.5V44.1667H31.1667C30.1542 44.1667 29.3334 44.9875 29.3334 46C29.3334 47.0125 30.1542 47.8333 31.1667 47.8333H34.8334V51.5C34.8334 52.5125 35.6542 53.3333 36.6667 53.3333C37.6792 53.3333 38.5 52.5125 38.5 51.5V47.8333H42.1667C43.1792 47.8333 44 47.0125 44 46C44 44.9875 43.1792 44.1667 42.1667 44.1667Z",
    fill: "#5196FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 46C22.5751 46 27.5 41.0751 27.5 35C27.5 28.9249 22.5751 24 16.5 24C10.4249 24 5.5 28.9249 5.5 35C5.5 41.0751 10.4249 46 16.5 46Z",
    fill: "#5196FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 49.6667C7.39148 49.6768 0.0101406 57.0582 0 66.1667C0 67.1792 0.820789 68 1.8333 68H31.1666C32.1791 68 32.9999 67.1792 32.9999 66.1667C32.9899 57.0582 25.6085 49.6767 16.5 49.6667Z",
    fill: "#5196FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3121_70345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusMan);
export default __webpack_public_path__ + "static/media/PlusMan.05500eaab3b0f95712f083328562ae30.svg";
export { ForwardRef as ReactComponent };